export enum messageTypes {
  commonMessage = 'commonMessage',
  actionMessage = 'actionMessage',
  generalInfoMessage = 'generalInfoMessage',
}
